import React, { useEffect } from "react";
import { motion, useReducedMotion } from "framer-motion";

export function LineReveal({ children, delay = 0, as: Tag = "span", className = "" }) {
  const reduce = useReducedMotion();
  return (
    <Tag className={`line-mask ${className}`}>
      <motion.span
        className="line-mask__inner"
        initial={reduce ? false : { y: "112%" }}
        animate={reduce ? undefined : { y: "0%" }}
        transition={{ duration: 1.05, ease: [0.16, 1, 0.3, 1], delay }}
      >
        {children}
      </motion.span>
    </Tag>
  );
}

export function Reveal({ children, delay = 0, y = 36, className = "", once = true }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={reduce ? undefined : { opacity: 1, y: 0 }}
      viewport={{ once, margin: "-8% 0px" }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay }}
    >
      {children}
    </motion.div>
  );
}

export function Marquee({ items }) {
  const row = items.map((item, i) => (
    <span className="marquee__item" key={i} aria-hidden={i >= items.length / 2}>
      {item}
      <span className="marquee__diamond">✦</span>
    </span>
  ));
  const doubled = [...items, ...items].map((item, i) => (
    <span className="marquee__item" key={i} aria-hidden={i >= items.length}>
      {item}
      <span className="marquee__diamond">✦</span>
    </span>
  ));
  void row;
  return (
    <div className="marquee" aria-hidden="true">
      <div className="marquee__track">{doubled}</div>
    </div>
  );
}

export function SmoothScroll() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    let lenis;
    let raf;
    let cancelled = false;
    import("lenis").then(({ default: Lenis }) => {
      if (cancelled) return;
      lenis = new Lenis({ duration: 1.15, smoothWheel: true });
      const loop = (time) => {
        lenis.raf(time);
        raf = requestAnimationFrame(loop);
      };
      raf = requestAnimationFrame(loop);
    });
    return () => {
      cancelled = true;
      if (raf) cancelAnimationFrame(raf);
      if (lenis) lenis.destroy();
    };
  }, []);
  return null;
}
